<template>
  <div id="travel">
    <v-container grid-list-md text-xs-center class="section">
      <v-layout class="section text-xs-left" row wrap>
        <v-flex xs12 md4>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4" max-height="400" flat>
              <v-card-text text-xs-right style="background-color: white">
                <span class="headline font-weight-bold">旅行，为生活充个电</span>
              </v-card-text>
              <v-img class="white--text wow fadeInLeft" :style="{height: device==='desktop' ? '395px' : ''}" :src="require('../../public/images/travel/b_01.png')">
                <v-expand-transition>
                  <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                    <v-container fill-height fluid>
                      <v-layout align-center>
                        <v-flex xs12 text-xs-center flexbox>
                          <div class="headline">希腊</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex d-flex xs12 md8 v-if="device==='mobile'">
          <v-flex d-flex>
            <v-hover>
              <v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4">
                <v-img class="white--text wow fadeInDown" :style="{width: device==='desktop' ? '100%' : '', height: device==='desktop' ? '200px' : ''}" :src="require('../../public/images/travel/b_02.png')">
                  <v-expand-transition>
                    <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                      <v-container fill-height fluid>
                        <v-layout align-center>
                          <v-flex xs12 text-xs-center flexbox>
                            <div class="headline">澳大利亚</div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-card>
            </v-hover>
          </v-flex>
        </v-flex>
        <v-flex d-flex xs12 md8 v-if="device==='mobile'">
          <v-flex d-flex>
            <v-hover>
              <v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4">
                <v-img class="white--text wow fadeInDown" :style="{width: device==='desktop' ? '100%' : '', height: device==='desktop' ? '200px' : ''}" :src="require('../../public/images/hotel/b_03.png')">
                  <v-expand-transition>
                    <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                      <v-container fill-height fluid>
                        <v-layout align-center>
                          <v-flex xs12 text-xs-center flexbox>
                            <div class="headline">西班牙</div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-card>
            </v-hover>
          </v-flex>
        </v-flex>
        <v-flex d-flex xs12 md8>
          <v-layout row wrap>
            <v-flex d-flex v-if="device==='desktop'">
              <v-layout row>
                <v-flex d-flex>
                  <v-hover>
                    <v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4">
                      <v-img class="white--text wow fadeInDown" :style="{width: device==='desktop' ? '400px' : ''}" :src="require('../../public/images/travel/b_02.png')">
                        <v-expand-transition>
                          <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                            <v-container fill-height fluid>
                              <v-layout align-center>
                                <v-flex xs12 text-xs-center flexbox>
                                  <div class="headline">澳大利亚</div>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-flex>
                <v-flex d-flex>
                  <v-hover>
                    <v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4">
                      <v-img class="white--text wow fadeInDown" :style="{width: device==='desktop' ? '400px' : ''}" :src="require('../../public/images/hotel/b_03.png')">
                        <v-expand-transition>
                          <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                            <v-container fill-height fluid>
                              <v-layout align-center>
                                <v-flex xs12 text-xs-center flexbox>
                                  <div class="headline">西班牙</div>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex d-flex>
              <v-hover>
                <v-card slot-scope="{ hover }" class="mx-auto" color="grey lighten-4">
                  <v-img class="white--text wow fadeInUp" :style="{width: device==='desktop' ? '800px' : '100%', height: device==='desktop' ? '200px' : ''}" :src="require('../../public/images/travel/b_04.png')">
                    <v-expand-transition>
                      <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                        <v-container fill-height fluid>
                          <v-layout align-center>
                            <v-flex xs12 text-xs-center flexbox>
                              <div class="headline">葡萄牙</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </div>
                    </v-expand-transition>
                  </v-img>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout class="section" row wrap>
      <v-flex xs12 md12 lg12 my-4>
        <div class="display-1 font-weight-bold">主题游</div>
      </v-flex>
      <v-flex xs6 md3 lg3>
        <v-hover>
          <v-card slot-scope="{ hover }" class="mx-auto" flat>
            <v-img class="wow fadeInUp" :src="require('../../public/images/travel/5_21.jpg')" :aspect-ratio="16/9">
              <v-expand-transition>
                <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                  <v-container fill-height fluid>
                    <v-layout align-center>
                      <v-flex xs12 text-xs-center flexbox>
                        <div class="headline">休闲赏景</div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-expand-transition>
            </v-img>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs6 md3 lg3>
        <v-hover>
          <v-card slot-scope="{ hover }" class="mx-auto" flat>
            <v-img class="wow fadeInDown" :src="require('../../public/images/travel/5_22.jpg')" :aspect-ratio="16/9">
              <v-expand-transition>
                <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                  <v-container fill-height fluid>
                    <v-layout align-center>
                      <v-flex xs12 text-xs-center flexbox>
                        <div class="headline">狩猎海钓</div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-expand-transition>
            </v-img>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs6 md3 lg3>
        <v-hover>
          <v-card slot-scope="{ hover }" class="mx-auto" flat>
            <v-img class="wow fadeInUp" :src="require('../../public/images/travel/5_23.jpg')" :aspect-ratio="16/9">
              <v-expand-transition>
                <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                  <v-container fill-height fluid>
                    <v-layout align-center>
                      <v-flex xs12 text-xs-center flexbox>
                        <div class="headline">婚拍旅拍</div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-expand-transition>
            </v-img>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs6 md3 lg3>
        <v-hover>
          <v-card slot-scope="{ hover }" class="mx-auto" flat>
            <v-img class="wow fadeInDown" :src="require('../../public/images/travel/5_24.jpg')" :aspect-ratio="16/9">
              <v-expand-transition>
                <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                  <v-container fill-height fluid>
                    <v-layout align-center>
                      <v-flex xs12 text-xs-center flexbox>
                        <div class="headline">亲子游学</div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-expand-transition>
            </v-img>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
    <v-container class="section" grid-list-md text-xs-center>
      <v-layout row wrap class="transition-img">
        <v-flex xs12 md12 lg12>
          <div class="title mb-4">#我们的服务团队　#贵宾服务礼遇</div>
        </v-flex>
        <v-flex xs4 md1 lg1 mx-auto>
          <v-img class="wow flipInY" max-width="100" :src="require('../../public/images/travel/5_41.png')">
          </v-img>
          <div class="body-2 my-2">摄影师</div>
        </v-flex>
        <v-flex xs4 md1 lg1 mx-auto>
          <v-img class="wow flipInY" max-width="100" :src="require('../../public/images/travel/5_42.png')">
          </v-img>
          <div class="body-2 my-2">随团厨师</div>
        </v-flex>
        <v-flex xs4 md1 lg1 mx-auto>
          <v-img class="wow flipInY" max-width="100" :src="require('../../public/images/travel/5_43.png')">
          </v-img>
          <div class="body-2 my-2">随行秘书</div>
        </v-flex>
        <v-flex xs4 md1 lg1 mx-auto>
          <v-img class="wow flipInY" max-width="100" :src="require('../../public/images/travel/5_45.png')">
          </v-img>
          <div class="body-2 my-2">在地站长</div>
        </v-flex>
        <v-flex xs4 md1 lg1 mx-auto>
          <v-img class="wow flipInY" max-width="100" :src="require('../../public/images/travel/5_44.png')">
          </v-img>
          <div class="body-2 my-2">户外向导</div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="section" grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 md12 lg12>
          <div class="display-1 font-weight-bold">海外教育</div>
        </v-flex>
        <v-flex xs12 md6 lg6 mx-auto>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto" flat>
              <v-img class="wow fadeInUp" :src="require('../../public/images/travel/c_01.jpg')" :aspect-ratio="16/9">
                <v-expand-transition>
                  <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                    <v-container fill-height fluid>
                      <v-layout align-center>
                        <v-flex xs12 text-xs-center flexbox>
                          <div class="display-2">[ 移 民 ]</div>
                          <div class="display-2">IMMIGRATION</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs12 md6 lg6 mx-auto>
          <v-hover>
            <v-card slot-scope="{ hover }" class="mx-auto" flat>
              <v-img class="wow fadeInUp" :src="require('../../public/images/travel/c_02.jpg')" :aspect-ratio="16/9">
                <v-expand-transition>
                  <div v-if="hover" class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                    <v-container fill-height fluid>
                      <v-layout align-center>
                        <v-flex xs12 text-xs-center flexbox>
                          <div class="display-2">[ 留 学 ]</div>
                          <div class="display-2">STUDY ABROAD</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<script>
import { WOW } from 'wowjs'

export default {
  data: () => ({
    device: 'desktop'
  }),
  created() {
    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
